import React from 'react';
import { FadeIn, Section } from './Section';
import { CheckIcon } from 'lucide-react';
const topics = ['Identidad', 'Mentalidad', 'Monetización', 'Independencia', 'Orden', 'Disciplina', 'Estabilidad', 'Expansión', 'Estándares', 'Emprendimiento', 'Recursos', 'Entorno', 'Abundancia', 'Alto valor'];
const results = ['Identidad de mujer de alto valor construida desde adentro', 'Independencia económica real y medible', 'Orden financiero y disciplina sostenida', 'Primera clienta o primera venta en 30 días', 'Vida diseñada según tus propios estándares'];
export function SystemOverview() {
  return <Section bg="plum" className="text-center md:text-left" data-id="element-280">
      <FadeIn className="mb-10 md:mb-16 text-center" data-id="element-281">
        <h2 className="text-xs md:text-sm font-bold tracking-[0.2em] uppercase text-gold mb-4" data-id="element-282">
          El Sistema Completo
        </h2>
        <p className="font-serif text-3xl md:text-6xl text-cream mb-4 md:mb-8" data-id="element-283">
          Mujer Expansiva
        </p>
        <p className="text-base md:text-xl text-cream/80 font-serif italic mb-6 md:mb-8" data-id="element-284">
          4 Partes + 5 Bonos · Transformación real en 30 días
        </p>
        <div className="flex flex-wrap justify-center gap-x-3 gap-y-2 text-[10px] md:text-sm font-bold tracking-widest uppercase text-cream/60" data-id="element-285">
          <span data-id="element-286">+180 páginas</span>
          <span className="hidden md:inline" data-id="element-287">·</span>
          <span data-id="element-288">Método paso a paso</span>
          <span className="hidden md:inline" data-id="element-289">·</span>
          <span data-id="element-290">Mentalidad + Estrategia</span>
          <span className="hidden md:inline" data-id="element-291">·</span>
          <span data-id="element-292">Acceso inmediato</span>
        </div>
      </FadeIn>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-16 items-start max-w-5xl mx-auto" data-id="element-293">
        <FadeIn delay={0.2} data-id="element-294">
          <h3 className="text-xs md:text-sm font-bold tracking-[0.2em] uppercase text-gold mb-4 md:mb-6" data-id="element-295">
            Lo que trabajamos
          </h3>
          <div className="flex flex-wrap gap-2 justify-center md:justify-start" data-id="element-296">
            {topics.map((topic, i) => <span key={i} className="px-3 py-1.5 md:px-4 md:py-2 border border-cream/20 text-cream/90 text-xs md:text-sm rounded-full" data-id="element-297">
                {topic}
              </span>)}
          </div>
          <p className="mt-6 md:mt-8 text-sm md:text-base text-cream/70 leading-relaxed" data-id="element-298">
            Funciona desde hoy, con la habilidad que ya tenés, sin audiencia
            previa y sin experiencia en ventas.
          </p>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-299">
          <h3 className="text-xs md:text-sm font-bold tracking-[0.2em] uppercase text-gold mb-4 md:mb-6" data-id="element-300">
            Resultados incluidos
          </h3>
          <ul className="space-y-3 md:space-y-4 text-left" data-id="element-301">
            {results.map((result, i) => <li key={i} className="flex items-start gap-3 md:gap-4" data-id="element-302">
                <CheckIcon className="text-gold flex-shrink-0 mt-0.5 md:mt-1" size={18} data-id="element-303" />
                <span className="text-cream/90 text-sm md:text-lg" data-id="element-304">
                  {result}
                </span>
              </li>)}
          </ul>
        </FadeIn>
      </div>
    </Section>;
}